import React, { useEffect, useState } from 'react';

import { fetchPartnerListData } from '../../services/portfolioService';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Portfolio.module.css';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { SERVER_URL } from '../../config';
import Pagination from '../../components/Paging/Pagination';

const PartnerPage = () => {

  const { pageIdx } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [partnerData, setPartnerData] = useState([]);
  const [pagingInfo, setPagingInfo] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 327);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);


  const partnerListData = async (pageIdx) => {
    const response = await fetchPartnerListData(pageIdx);
    setPartnerData(response.ptList);
    setPagingInfo(response.pageInfo);
  }

  useEffect(() => {
    partnerListData(pageIdx);
  }, [location, pageIdx])

  const onPageChangeHandler = (pageNumber) => {
    navigate(`/portfolio/partner/${pageNumber}`)
  }

  return (
    <div>
      <HeaderComponents pageKey="portfolio" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="portfolio" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            <div id={S.lineDiv}></div>
            <div id={S.ptListWrap}>
              {partnerData.map((partner, index) => (
                <Link to={`/portfolio/partner/detail/${partner.PT_IDX}`} className='text-line-none' key={index}>
                  <div className={S.ptDataDiv}>
                    <div className={S.ptListImgDiv}>
                      <img className={S.ptListImg} src={SERVER_URL + partner.PT_THUMBNAIL} alt='listImg'/>
                    </div>
                    <div className={isMobile() ? 'mt-10' : 'mt-20'}>{partner.PT_USE}</div>
                    <div>{partner.PT_SPEC}</div>
                    <div>{partner.PT_PRD_NAME}</div>
                  </div>
                </Link>
              ))}
            </div>
            <Pagination 
              currentPage={pagingInfo.curPage}
              totalPages={pagingInfo.totalPage}
              onPageChangeHandler={onPageChangeHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerPage;
